/* =====================================================================
   THE CLEAN SHAVE - COLLECTION + PAGES INTERACTIVITY (tcs-col-app.js)
   Reviews carousel, FAQ page topic filter + live search, contact page
   copy-email, guides hub search + hover preview, stat count-up,
   timeline progress. Hooks are data- attributes and stable classes.
   Guarded so duplicate script tags never double-bind.
   ===================================================================== */
(function () {
  'use strict';
  if (window.__tcsColApp) return;
  window.__tcsColApp = true;

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ---- Reviews carousel: snap-scroll with arrows ---- */
  function initReviews(root) {
    var track = root.querySelector('[data-reviews-track]');
    if (!track) return;
    var prev = root.querySelector('[data-rev-prev]');
    var next = root.querySelector('[data-rev-next]');
    function step() {
      var card = track.querySelector('.review-card');
      return card ? card.getBoundingClientRect().width + 20 : 320;
    }
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
  }

  /* ---- FAQ page: topic pills + live search ---- */
  function initFaqPage(root) {
    var pills = [].slice.call(root.querySelectorAll('.topic-pill'));
    var groups = [].slice.call(root.querySelectorAll('.faq-group'));
    var input = root.querySelector('[data-faq-search]');
    var countEl = root.querySelector('[data-faq-count]');
    var empty = root.querySelector('[data-faq-empty]');
    var total = 0;
    var items = [];
    groups.forEach(function (g) {
      g.querySelectorAll('.faq-item').forEach(function (it) {
        var q = it.querySelector('.faq-q');
        var a = it.querySelector('.faq-a p');
        items.push({ el: it, group: g, qEl: q, qText: q ? q.childNodes[0].textContent : '', aText: a ? a.textContent : '' });
        total++;
      });
    });
    function mark(item, q) {
      if (!item.qEl) return;
      var t = item.qText;
      var node = item.qEl.childNodes[0];
      if (!q) {
        if (node.nodeType === 3) node.textContent = t;
        else item.qEl.replaceChild(document.createTextNode(t), node);
        return;
      }
      var i = t.toLowerCase().indexOf(q);
      if (i < 0) { mark(item, ''); return; }
      var span = document.createElement('span');
      span.appendChild(document.createTextNode(t.slice(0, i)));
      var m = document.createElement('mark');
      m.textContent = t.slice(i, i + q.length);
      span.appendChild(m);
      span.appendChild(document.createTextNode(t.slice(i + q.length)));
      item.qEl.replaceChild(span, node);
    }
    function activeTopic() {
      var p = root.querySelector('.topic-pill.active');
      return p ? p.dataset.topic : 'all';
    }
    function apply() {
      var q = input ? input.value.trim().toLowerCase() : '';
      var topic = activeTopic();
      var shown = 0;
      groups.forEach(function (g) {
        var vis = 0;
        items.forEach(function (it) {
          if (it.group !== g) return;
          var hit = !q || it.qText.toLowerCase().indexOf(q) > -1 || it.aText.toLowerCase().indexOf(q) > -1;
          it.el.classList.toggle('hide', !hit);
          mark(it, hit ? q : '');
          if (hit) vis++;
        });
        var topicHide = !q && topic !== 'all' && g.dataset.topic !== topic;
        g.classList.toggle('hidden', topicHide || (!!q && vis === 0));
        if (!topicHide) shown += vis;
      });
      if (countEl) countEl.textContent = q ? shown + (shown === 1 ? ' match' : ' matches') : total + ' questions';
      if (empty) empty.classList.toggle('show', !!q && shown === 0);
    }
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.classList.remove('active'); });
        pill.classList.add('active');
        if (input) input.value = '';
        apply();
      });
    });
    if (input) input.addEventListener('input', apply);
  }

  /* ---- Copy email pill ---- */
  function initCopyEmail() {
    document.querySelectorAll('[data-copy-email]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var email = btn.dataset.copyEmail;
        var label = btn.querySelector('span');
        function done() {
          btn.classList.add('copied');
          if (label) label.textContent = 'Copied';
          setTimeout(function () {
            btn.classList.remove('copied');
            if (label) label.textContent = email;
          }, 1600);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(email).then(done, function () { window.location.href = 'mailto:' + email; });
        } else {
          window.location.href = 'mailto:' + email;
        }
      });
    });
  }

  /* ---- Guides hub: live search + floating hover preview ---- */
  function initGuides(root) {
    var input = root.querySelector('[data-guide-search]');
    var rows = [].slice.call(root.querySelectorAll('.guide-row'));
    var featured = root.querySelector('[data-featured-guide]');
    var empty = root.querySelector('[data-guide-empty]');
    if (input) {
      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        var shown = 0;
        rows.forEach(function (row) {
          var hit = !q || row.textContent.toLowerCase().indexOf(q) > -1;
          row.classList.toggle('hide', !hit);
          if (hit) shown++;
        });
        if (featured) {
          var fHit = !q || featured.textContent.toLowerCase().indexOf(q) > -1;
          featured.classList.toggle('hide', !fHit);
          if (fHit) shown++;
        }
        if (empty) empty.classList.toggle('show', !!q && shown === 0);
      });
    }
    var preview = root.querySelector('[data-guide-preview]');
    if (preview) {
      var img = preview.querySelector('img');
      rows.forEach(function (row) {
        row.addEventListener('mouseenter', function () {
          if (img && row.dataset.img) { img.src = row.dataset.img; preview.classList.add('on'); }
        });
        row.addEventListener('mouseleave', function () { preview.classList.remove('on'); });
        row.addEventListener('mousemove', function (e) {
          preview.style.left = (e.clientX + 26) + 'px';
          preview.style.top = (e.clientY - 60) + 'px';
        });
      });
    }
  }

  /* ---- Stat counters: count up on first view ---- */
  function initStats() {
    var els = document.querySelectorAll('.stat-num[data-count]');
    if (!els.length) return;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) return; /* static end-state already in markup */
    function fmt(n, el) {
      return (el.dataset.prefix || '') + Math.round(n).toLocaleString('en-US') + (el.dataset.suffix || '');
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target;
        var target = +el.dataset.count;
        var start = null;
        function tick(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / 1100, 1);
          el.textContent = fmt(target * (1 - Math.pow(1 - p, 3)), el);
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Timeline lights up as you pass it ---- */
  function initTimeline() {
    var items = [].slice.call(document.querySelectorAll('.tl-item'));
    if (!items.length) return;
    function update() {
      var line = window.innerHeight * 0.62;
      items.forEach(function (it) {
        it.classList.toggle('passed', it.getBoundingClientRect().top < line);
      });
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  onReady(function () {
    document.querySelectorAll('[data-reviews]').forEach(initReviews);
    document.querySelectorAll('[data-faq-page]').forEach(initFaqPage);
    document.querySelectorAll('[data-guides-hub]').forEach(initGuides);
    initCopyEmail();
    initStats();
    initTimeline();
  });
})();
